import { useEffect, useRef } from "react";

// Calls callback every intervalMs while the tab is visible. A hidden tab skips its
// polls and catches up once when it becomes visible again, unless it polled within
// the last interval. A change in deps restarts the interval.
const usePolling = (callback, intervalMs, deps = []) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(
    () => {
      let lastPolledAt = Date.now();

      const poll = () => {
        lastPolledAt = Date.now();
        callbackRef.current();
      };

      const pollIfVisible = () => {
        if (document.visibilityState === "visible") {
          poll();
        }
      };

      const pollIfStale = () => {
        if (document.visibilityState === "visible" && Date.now() - lastPolledAt >= intervalMs) {
          poll();
        }
      };

      const interval = setInterval(pollIfVisible, intervalMs);
      document.addEventListener("visibilitychange", pollIfStale);

      return () => {
        clearInterval(interval);
        document.removeEventListener("visibilitychange", pollIfStale);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [intervalMs, ...deps],
  );
};

export default usePolling;
